import { Loading } from '@nike/frame-component-library';
import PropTypes from 'prop-types';
import React, { useCallback, useEffect, useState } from 'react';

import { productGet } from '../../../utils/service-calls/store-data-validation';
import { ButtonBlack } from '../../reusable';

const ProductTab = ({ accessToken, selectedStore }) => {
  const [count, setCount] = useState(null);
  const [error, setError] = useState('');
  const [notFound, setNotFound] = useState(false);
  const [fetched, setFetched] = useState(false);
  const [loading, setLoading] = useState(false);
  const [isExpanded, setIsExpanded] = useState(true);

  const locationId = selectedStore?.id;
  const hasStore = Boolean(locationId);

  useEffect(() => {
    setCount(null);
    setError('');
    setNotFound(false);
    setFetched(false);
    setLoading(false);
  }, [locationId]);

  const toggleExpanded = useCallback(() => {
    setIsExpanded((prev) => !prev);
  }, []);

  const handleFetch = useCallback(() => {
    if (!locationId) return;
    setError('');
    setNotFound(false);
    setFetched(false);
    setLoading(true);
    setIsExpanded(true);
    productGet(accessToken, locationId)
      .then((res) => {
        setCount(res?.body?.count ?? 0);
        setFetched(true);
        setLoading(false);
        return null;
      })
      .catch((err) => {
        setCount(null);
        if (err?.statusCode === 404) {
          setNotFound(true);
        } else {
          setError(err?.message || 'Failed to fetch products.');
        }
        setFetched(true);
        setLoading(false);
      });
  }, [accessToken, locationId]);

  return (
    <section className={`sdv-card ${isExpanded ? '' : 'sdv-card-collapsed'}`}>
      <header className="sdv-card-header">
        <button
          aria-expanded={isExpanded}
          className="sdv-card-toggle"
          type="button"
          onClick={toggleExpanded}
        >
          <span aria-hidden="true" className={`sdv-card-chevron ${isExpanded ? 'sdv-card-chevron-open' : ''}`}>▸</span>
          <h2 className="sdv-card-title">Product</h2>
        </button>
        <ButtonBlack
          isDisabled={!hasStore || loading}
          label={loading ? 'Getting...' : 'Get'}
          onClick={handleFetch}
        />
      </header>
      {isExpanded && (
        <div className="sdv-card-body">
          {error && (
            <p className="sdv-status-message sdv-status-error">{error}</p>
          )}
          {loading && <Loading />}
          {!loading && fetched && notFound && (
            <p className="sdv-card-hint">No product data found for this store.</p>
          )}
          {!loading && fetched && count !== null && (
            <p className="sdv-table-caption">{`${count.toLocaleString()} product(s) found.`}</p>
          )}
        </div>
      )}
    </section>
  );
};

ProductTab.defaultProps = {
  selectedStore: null,
};

ProductTab.propTypes = {
  accessToken: PropTypes.string.isRequired,
  selectedStore: PropTypes.shape({
    id: PropTypes.string,
  }),
};

export default ProductTab;
